import React, { useEffect } from "react";

function IQACombudsman() {
  useEffect(() => {
    // Redirect to the PDF in public folder
    window.location.href = "/Appointment_of_Ombudsman.pdf";
  }, []);

  return null; // nothing is rendered
}

export default IQACombudsman;
